<header class="container-fluid masthead text-center text-black" id="page-top">
  <div class="my-auto">
    <div class="row">
      <div id="logo" class="col-lg-10 mx-auto pt-5">
          <img src="/assets/img/logos/logo1.png">
          <app-social></app-social>
      </div>
      <!--<div class="col-lg-10 mx-auto">
        <div class="bg-black-trans text-white m-0 p-3">
            <div class="row">
              <div class="col-md-12 text-left">
                <div class="mt-0">Brian Alan Hager’s music is a soulful fusion of blues‑tinged indie rock and alternative pop—with a touch of jam‑band improvisation and throwback flair. Rooted in early inspiration from blues‑rock artists like The Black Keys and Tedeschi Trucks, his guitar‑driven sound blends laid‑back synth textures, emotional melodies, and spirited riffs. Whether solo or with his full band—including his cousin Jeff and regional musicians—his live performances are energetic and improvisational, delivering fresh interpretations of his catalog in a lively jam format. <a href="https://linktr.ee/brianalanhager" target="_new">Listen on your prefered streaming platform. </a>
                <div class="row">
                  <div class="col-md-4 text-center">
                    <a href="https://linktr.ee/brianalanhager" target="_new"><img class="img-fluid" src="/assets/img/BandPhotos/band1Square2.jpg" height="200" width="200" border="0" class="align-top" alt="The Brian Alan Hager Band"></a>
                  </div>
                 <div class="col-md-8 text-center">
                    <div class="mt-3">Brian Alan Hager’s music is a soulful fusion of blues‑tinged indie rock and alternative pop—with a touch of jam‑band improvisation and throwback flair. Rooted in early inspiration from blues‑rock artists like The Black Keys and Tedeschi Trucks, his guitar‑driven sound blends laid‑back synth textures, emotional melodies, and spirited riffs. <a href="https://linktr.ee/brianalanhager" target="_new">Listen on your prefered streaming platform.</a>
                    </div>
                    <div class="mt-3">Critics liken his style to “John Mayer meets Radiohead featuring Keith Richards,” a nod to his melodic songwriting infused with raw, bluesy energy. His arrangements often feature acoustic and electric guitar, bass, percussion, and synth, creating rich, multi‑layered soundscapes punctuated by spontaneous blues–rock and jazz solos. Whether solo or with his full band—including his cousin Jeff and regional musicians—his live performances are energetic and improvisational, delivering fresh interpretations of his catalog in a lively jam format. The result is a vibrant, genre‑blending style: part heartfelt blues-rock, part inventive indie-pop, all delivered with authenticity and musical craftsmanship.
                    </div>
                  </div>

                </div>
                <app-social></app-social>
              </div>
            </div>
          </div>
      </div>-->
    </div>
  </div>
</header>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Sample Song List</h4>
     <button type="button"
             class="close pull-right"
             (click)="modalRef.hide()">
         <span aria-hidden="true">&times;</span>
     </button>
  </div>

  <!-- Modal Body -->
  <app-song-list></app-song-list>
</ng-template>
